module.exports = __webpack_public_path__ + "img/bg_honor_desk_1.8813bf36.png";